var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 461,
    viewBox: "0 0 456 461",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_739_7493)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 117.5,
    rx: 253,
    ry: 240.5,
    fill: "url(#paint0_radial_739_7493)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_739_7493",
    x: -256,
    y: -226,
    width: 712,
    height: 687,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 51.5,
    result: "effect1_foregroundBlur_739_7493"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_739_7493",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100 117.5) rotate(44.4688) scale(266.944 280.819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A161DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A161DF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/ellipse.c068befce58724945fee5171e8185aee.svg";
export { ForwardRef as ReactComponent };